module.exports = __webpack_public_path__ + "static/media/legionella_2.447bd618.svg";